import Swal from 'sweetalert2';

import { types } from "../types/types";
import { fetchConToken, archivoConToken } from '../helpers/fetch';
import { openModal, openModalBottom } from './ui';
import { refreshProfesional } from './profesionales';

export const startNewServicio = ( values, swal = true ) => {
    return async( dispatch, getState ) => {
        try {
            const resp = await fetchConToken( 'servicios', { values, empresa: values.empresa }, 'POST' );
            const body = await resp.json();
            console.log( body );
            if( body.ok ) {
                const state = getState();
                
                if ( body.servicio.complementarios && body.servicio.complementarios.length > 0 ) {
                    body.servicio.complementarios.forEach( (complementarioId) => {
                        const servicioComplementario = state.servicios.servicios.find( s => s._id === complementarioId );
                        if ( servicioComplementario ) {
                            const nuevosComplementarios = servicioComplementario.complementarios || [];
                            if ( !nuevosComplementarios.includes( body.servicio._id ) ) {
                                const servicioActualizado = {
                                    ...servicioComplementario,
                                    complementarios: [...nuevosComplementarios, body.servicio._id]
                                };
                                dispatch( refreshServicio( complementarioId, servicioActualizado ) );
                            }
                        }
                    });
                }
                
                if ( body.servicio.profesionales && body.servicio.profesionales.length > 0 ) {
                    body.servicio.profesionales.forEach( (profesionalId) => {
                        const profesionalIdStr = typeof profesionalId === 'object' && profesionalId._id ? profesionalId._id.toString() : profesionalId.toString();
                        const profesional = state.profesionales.profesionales.find( p => {
                            const pIdStr = p._id.toString();
                            return pIdStr === profesionalIdStr;
                        });
                        if ( profesional ) {
                            const serviciosActuales = profesional.servicios || [];
                            const servicioIdStr = body.servicio._id.toString();
                            if ( !serviciosActuales.some( sId => {
                                const sIdStr = typeof sId === 'object' && sId._id ? sId._id.toString() : sId.toString();
                                return sIdStr === servicioIdStr;
                            }) ) {
                                const profesionalActualizado = {
                                    ...profesional,
                                    servicios: [...serviciosActuales, body.servicio._id]
                                };
                                dispatch( refreshProfesional( profesional._id, profesionalActualizado ) );
                            }
                        }
                    });
                }
                
                const datos = {
                    text: [ `Servicio creado correctamente` ],
                    timeOut: 3
                }
                dispatch( openModalBottom( datos ) );
                dispatch( addNewServicio( body.servicio._id, body.servicio ) );
                return body.servicio;
            }else{
                console.log('Error!!!');
                console.log(body.errors);
            }
        } catch (error) {
            console.log('Error!!!');
            console.log( error );
            const datos = {
                title: 'Error',
                text: [ 'Ha habido un error' ],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
        }
    }
};

export const activeServices = ( _id, services ) => ({
    type: types.serviciosActive,
    payload: {
        ...services
    }
});

export const activeServicio = ( _id, servicio ) => ({
    type: types.serviciosActive,
    payload: {
        _id,
        ...servicio
    }
});

export const unactiveServicio = () => ({
    type: types.serviciosUnactive
});

export const addNewServicio = ( _id, servicio ) => ({
    type: types.serviciosAddNew,
    payload: {
        _id,
        ...servicio
    }
})

export const startLoadingServicios = ( empresa ) => {
    return async( dispatch, getState ) => {
        const state = getState();
        
        if (state.servicios.servicios && state.servicios.servicios.length > 0) {
            const serviciosEmpresa = state.servicios.servicios.filter(s => s.empresa === empresa);
            if (serviciosEmpresa.length > 0) {
                return;
            }
        }
        
        try {
            const resp = await fetchConToken( 'servicios/empresa', {empresa}, 'POST' );
            const body = await resp.json();
            dispatch( setServicios( body.servicios ));
        } catch (error) {
            console.log(error);
        }
    }
};

export const setServicios = ( servicios ) => ({
    type: types.serviciosLoad,
    payload: servicios
})

export const startSaveServicio = ( servicio, swal = true ) => {
    return async( dispatch, getState ) => {
        
        try {
            const resp = await fetchConToken( `servicios/${ servicio._id }`, servicio, 'PUT' );
            const body = await resp.json();
            if ( body.ok ) {
                const stateAntes = getState();
                const servicioAnterior = stateAntes.servicios.servicios.find( s => s._id === servicio._id );
                const complementariosAnteriores = servicioAnterior?.complementarios || [];
                const complementariosNuevos = body.servicio.complementarios || [];
                const profesionalesAnteriores = servicioAnterior?.profesionales || [];
                const profesionalesNuevos = body.servicio.profesionales || [];
                
                dispatch( refreshServicio( body.servicio._id, body.servicio ) );
                
                const state = getState();
                
                const agregados = complementariosNuevos.filter( id => !complementariosAnteriores.includes( id ) );
                
                const eliminados = complementariosAnteriores.filter( id => !complementariosNuevos.includes( id ) );
                
                agregados.forEach( (complementarioId) => {
                    const servicioComplementario = state.servicios.servicios.find( s => s._id === complementarioId );
                    if ( servicioComplementario ) {
                        const nuevosComplementarios = servicioComplementario.complementarios || [];
                        if ( !nuevosComplementarios.includes( servicio._id ) ) {
                            const servicioActualizado = {
                                ...servicioComplementario,
                                complementarios: [...nuevosComplementarios, servicio._id]
                            };
                            dispatch( refreshServicio( complementarioId, servicioActualizado ) );
                        }
                    }
                });
                
                eliminados.forEach( (complementarioId) => {
                    const servicioComplementario = state.servicios.servicios.find( s => s._id === complementarioId );
                    if ( servicioComplementario ) {
                        const complementariosActuales = servicioComplementario.complementarios || [];
                        const nuevosComplementarios = complementariosActuales.filter( id => id !== servicio._id );
                        const servicioActualizado = {
                            ...servicioComplementario,
                            complementarios: nuevosComplementarios
                        };
                        dispatch( refreshServicio( complementarioId, servicioActualizado ) );
                    }
                });
                
                const profesionalesAgregados = profesionalesNuevos.filter( id => {
                    const idStr = typeof id === 'object' && id._id ? id._id.toString() : id.toString();
                    return !profesionalesAnteriores.some( antId => {
                        const antIdStr = typeof antId === 'object' && antId._id ? antId._id.toString() : antId.toString();
                        return antIdStr === idStr;
                    });
                });
                
                const profesionalesEliminados = profesionalesAnteriores.filter( antId => {
                    const antIdStr = typeof antId === 'object' && antId._id ? antId._id.toString() : antId.toString();
                    return !profesionalesNuevos.some( nuevoId => {
                        const nuevoIdStr = typeof nuevoId === 'object' && nuevoId._id ? nuevoId._id.toString() : nuevoId.toString();
                        return nuevoIdStr === antIdStr;
                    });
                });
                
                profesionalesAgregados.forEach( (profesionalId) => {
                    const profesionalIdStr = typeof profesionalId === 'object' && profesionalId._id ? profesionalId._id.toString() : profesionalId.toString();
                    const profesional = state.profesionales.profesionales.find( p => {
                        const pIdStr = p._id.toString();
                        return pIdStr === profesionalIdStr;
                    });
                    if ( profesional ) {
                        const serviciosActuales = profesional.servicios || [];
                        const servicioIdStr = servicio._id.toString();
                        if ( !serviciosActuales.some( sId => {
                            const sIdStr = typeof sId === 'object' && sId._id ? sId._id.toString() : sId.toString();
                            return sIdStr === servicioIdStr;
                        }) ) {
                            const profesionalActualizado = {
                                ...profesional,
                                servicios: [...serviciosActuales, servicio._id]
                            };
                            dispatch( refreshProfesional( profesional._id, profesionalActualizado ) );
                        }
                    }
                });
                
                profesionalesEliminados.forEach( (profesionalId) => {
                    const profesionalIdStr = typeof profesionalId === 'object' && profesionalId._id ? profesionalId._id.toString() : profesionalId.toString();
                    const profesional = state.profesionales.profesionales.find( p => {
                        const pIdStr = p._id.toString();
                        return pIdStr === profesionalIdStr;
                    });
                    if ( profesional ) {
                        const serviciosActuales = profesional.servicios || [];
                        const servicioIdStr = servicio._id.toString();
                        const nuevosServicios = serviciosActuales.filter( sId => {
                            const sIdStr = typeof sId === 'object' && sId._id ? sId._id.toString() : sId.toString();
                            return sIdStr !== servicioIdStr;
                        });
                        const profesionalActualizado = {
                            ...profesional,
                            servicios: nuevosServicios
                        };
                        dispatch( refreshProfesional( profesional._id, profesionalActualizado ) );
                    }
                });
                
                const datos = {
                    text: [ `${ servicio.nombre } guardado correctamente` ],
                    timeOut: 3
                }
                dispatch( openModalBottom( datos ) );
            } else {
                console.log( body );
                const datos = {
                    title: 'Error',
                    text: [ body.msg ],
                    buttonText: 'Cerrar'
                }
                dispatch( openModal( datos ) );
            }

            
        } catch (error) {
            console.log(error);
        }
    }
};

export const refreshServicio = ( id, servicio ) => ({
    type: types.serviciosUpdated,
    payload: {
        ...servicio
    }
});

export const startUploading = ( archivo, servicio, nombre, previa ) => {

    return async ( dispatch, getState ) => {
        try {           
            const formData = new FormData();
            
            // console.log( archivo );
            
            formData.append('archivo', archivo);
            formData.append('empresa', servicio.empresa);
            formData.append('nombre', nombre);
            formData.append('previa', previa);
            formData.append('file_name', 'archivo');

            //console.log( formData );
    
            const resp = await archivoConToken( `servicios/upload/${ servicio._id }`, formData, 'POST' );
            const body = await resp.json();

            if (body.nombre) {
                const updatedServicio = {
                    ...servicio,
                    img: [body.nombre]
                };
                
                dispatch(activeServicio(servicio._id, updatedServicio));
                
                const state = getState();
                const updatedServicios = state.servicios.servicios.map(s => 
                    s._id === servicio._id ? updatedServicio : s
                );
                dispatch(setServicios(updatedServicios));
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }  

        Swal.close();
    }
};

export const servicioStartDelete = ( id, empresa ) => {
    return async( dispatch, getState ) => {

        try {
            const resp = await fetchConToken( `servicios/${ id }`, {empresa}, 'DELETE' );
            const body = await resp.json();

            if ( body.ok ) {
                console.log( 'servicioDeleted', id );
                dispatch( servicioDeleted( id ) );
            } else {
                const datos = {
                    title: 'Error',
                    text: [ body.msg ],
                    buttonText: 'Cerrar'
                }
                dispatch( openModal( datos ) );
            }

            
        } catch (error) {
            console.log(error);
        }
    }
}

export const serviciosReorder = ( serviciosList, empresa ) => {
    return async( dispatch, getState ) => {
        try {
            const serviciosParaEnviar = serviciosList.map(s => ({
                _id: s._id,
                orden: s.orden
            }));
            
            const resp = await fetchConToken( `servicios/reorder`, {serviciosList: serviciosParaEnviar, empresa}, 'POST', 60000 );
            
            if (!resp.ok) {
                const errorText = await resp.text();
                console.error('Error al reordenar servicios:', resp.status, errorText);
                throw new Error(`HTTP error! status: ${resp.status}`);
            }
            
            const body = await resp.json();
            
            if ( body.ok ) {
                const respReload = await fetchConToken( 'servicios/empresa', {empresa}, 'POST' );
                const bodyReload = await respReload.json();
                if ( bodyReload.servicios ) {
                    dispatch( setServicios( bodyReload.servicios ));
                }
            } else {
                console.error('Error al guardar orden:', body);
            }
            
        } catch (error) {
            console.error('Error al reordenar servicios:', error);
        }
    }
};

const servicioDeleted = ( id ) => ({
    type: types.serviciosDelete,
    payload: id
});

export const servicioLogout = () => ({
    type: types.serviciosLogoutCleaning
});
